import React from 'react';
import UserDropdown from './components/userDropdown';
import MenuIcon from '@material-ui/icons/Menu';
import { IconButtonCustom, HeaderAdmin, HeaderTitle } from '../../index';

class Header extends React.Component {
  render() {
    const { open, drawerWidth, selectedIndex } = this.props;
    return (
      <React.Fragment>
        <HeaderAdmin open={open} drawerWidth={drawerWidth}>
          <IconButtonCustom
            open={open}
            onClick={this.props.handleDrawerOpen}
            isWhite={false}
          >
            <MenuIcon />
          </IconButtonCustom>
          {selectedIndex === 0 ? (
            <HeaderTitle open={open}>Home</HeaderTitle>
          ) : null}
          {selectedIndex === 1 ? (
            <HeaderTitle open={open}>Demand users</HeaderTitle>
          ) : null}
          {selectedIndex === 2 ? (
            <HeaderTitle open={open}>Company users</HeaderTitle>
          ) : null}
        </HeaderAdmin>
        <UserDropdown />
      </React.Fragment>
    );
  }
}

export default Header;
